import React from "react"

import Testimonial from '../components/testimonial';
import Layout from "../components/layout"
import { FooterAlternate1 } from "../components/footer"
import SEO from "../components/seo";

const IndexPage = ({ location }) => (
    <Layout location={location}>
      <SEO title="Testimonials" />
      <div class="testimonial-content">
        <div class="testimonial-container" style={{display: 'flex', textAlign: 'center', width: '100%', flexDirection: 'column'}}>
          <Testimonial text="The SalesTribe Social Selling program is world class and is creating MASSIVE sales performance uplift across AON UK." from="Robert Michael - Director of Sales & Marketing (AON UK & Ireland)"/>
          <Testimonial text="SalesTribe’s Social Selling program has created a significant increase in new sales leads and opportunities, and helped us to better engage our customers." from="John Merakovsky – CEO (Integrated Research Ltd)"/>
        </div>

        <div class="testimonial-logos">
          <img alt="SalesTribe" src="../media/images/testimonial-logos/aon.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/salesforce.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/lloyds.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/nespresso.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/ir.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/hilton.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/telstra.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/canon.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/greenorbit.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/vocus.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/arkadin.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/pitcher-partners.png"></img>
          <img alt="SalesTribe" src="../media/images/testimonial-logos/vizolution.png"></img>
        </div>
      </div>
     
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 